module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-entity-button"
  }, [_c('ModalReveal', {
    ref: ("maintenance-" + _vm._uid),
    attrs: {
      "value": _vm.open
    }
  }, [(!_vm.open) ? [(_vm.request) ? _c('button', {
    staticClass: "button success",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Complete")]) : _vm._e()] : _vm._e(), _c('h2', [_vm._v("Complete Intervention request IR" + _vm._s(_vm.request.id) + "?")]), (_vm.request.linked_requests.length) ? [_c('label', [_vm._v("Complete linked requests?")]), _c('input-switch', {
    model: {
      value: (_vm.body.complete_all),
      callback: function($$v) {
        _vm.$set(_vm.body, "complete_all", $$v)
      },
      expression: "body.complete_all"
    }
  })] : _vm._e(), _c('ActionButton', {
    attrs: {
      "slot": "footer",
      "action": _vm.save
    },
    slot: "footer"
  }, [_vm._v("Save")]), _c('button', {
    staticClass: "button alert float-right",
    attrs: {
      "slot": "footer"
    },
    on: {
      "click": function($event) {
        _vm.$refs[("maintenance-" + _vm._uid)].close()
      }
    },
    slot: "footer"
  }, [_vm._v("Cancel")])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2198182f!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/CompleteInterventionRequestReveal.vue
// module id = 2331
// module chunks = 1